import { Component } from '@angular/core';

@Component({
  selector: 'fnsr-mail',
  templateUrl: './mail.component.html'
})
export class MailComponent {
  constructor() { }
}
